import Cookies from 'js-cookie';
import {
  BASE_LOGIN_COOKIE_KEY,
  getConfig,
  getLoginCookieKey,
  IOA_LOGIN_COOKIE_KEY,
} from '../../../config';
import { getDomain } from '../../../lib';
import { DeployArea } from '../../../model';

export const VISITOR_TOKEN = 'visitor';

export const setCookieToken = (ticket: string) => {
  const date = new Date();
  const hour = 11 * 60 * 60 * 1000; // 11小时过期
  const expireTime = Number(Date.parse(String(date)) + hour);

  const opt = {
    path: '/',
    expires: new Date(expireTime),
    domain: getDomain(),
  };

  if (getConfig().deployArea === DeployArea.woa) {
    Cookies.set(IOA_LOGIN_COOKIE_KEY, ticket, {
      ...opt,
      domain: location.hostname,
    });
  }

  Cookies.set(BASE_LOGIN_COOKIE_KEY, ticket, opt);
  if (getLoginCookieKey()) {
    Cookies.set(getLoginCookieKey(), ticket, opt);
  }
};

export const removeCookieToken = () => {
  const domain = getDomain();
  const opt = {
    path: '/',
    domain,
  };
  Cookies.remove(BASE_LOGIN_COOKIE_KEY, opt);
  Cookies.remove(getLoginCookieKey(), opt);
};

export const getCookieToken = () => {
  return Cookies.get(getLoginCookieKey()) || '';
};

export const getIoaCookieToken = () => {
  return (
    Cookies.get(getLoginCookieKey()) || Cookies.get(IOA_LOGIN_COOKIE_KEY) || ''
  );
};
// export function checkUserLogin() {
//   const ticket = getLoginCookie('INTL_GCLOUD_TICKET');// eslint-disable-line
//   if (ticket === "") {
//       return false;
//   }
//   return ticket;
// }
